import { getCurrentDateTime } from '../../../../../utilities/dateTime.util'
import { BodySurveyConstants } from './bodySurvey.constants'
import { IBodySurveyAction, IBodySurveyState } from './bodySurvey.types'

export const initialBodySurveyState: IBodySurveyState = {
  seq: 0,
  assessDt: getCurrentDateTime(),
  examValues: [],
  examValuesPNNVs: [],
  findings: [],
  __examValues: [],
  __examValuesPNNVs: [],
  __deleteExam: null,
  __zoomedBodyPart: null,
  __selectedBodyPart: null,
  __selectedBodyParts: [],
  __comments: '',
  __documentFindings: false,
  __deleteBodyLocationFinding: null,
  __chestLungMode: { id: 1, name: 'Front' },
  __deleteSummaryExams: [],
  __deleteSummaryFindings: [],
  __sequenceOperationType: '',
  __examinationInProgress: false,
  __enabledZoom: false,
  __setDefaults: false,
  __setZoomVisible: false,
  __bod: false,
}

export function bodySurveyReducer(
  state: IBodySurveyState = initialBodySurveyState,
  action: IBodySurveyAction
): IBodySurveyState {
  switch (action.type) {
    case BodySurveyConstants.SET_ASSESSMENT_SEQ:
      return { ...state, seq: action.seq }
    case BodySurveyConstants.SET_EXAM_VALUE:
      return { ...state, examValues: action.examValues }
    case BodySurveyConstants.SET_EXAM_PNNV_VALUE:
      return { ...state, examValuesPNNVs: action.examValuesPNNVs }
    case BodySurveyConstants.UPDATE_EXAM_VALUE:
      return { ...state, __examValues: action.__examValues }
    case BodySurveyConstants.UPDATE_EXAM_PNNV_VALUE:
      return { ...state, __examValuesPNNVs: action.__examValuesPNNVs }
    case BodySurveyConstants.SET_FINDINGS_VALUE:
      return { ...state, findings: action.findings }
    case BodySurveyConstants.SET_DATE_TIME:
      return { ...state, assessDt: action.assessDt }
    case BodySurveyConstants.SET_ZOOMED_BODY_PART:
      return { ...state, __zoomedBodyPart: action.__zoomedBodyPart }
    case BodySurveyConstants.SET_SELECTED_BODY_PART:
      return { ...state, __selectedBodyPart: action.__selectedBodyPart }
    case BodySurveyConstants.SET_SELECTED_BODY_PARTS:
      return { ...state, __selectedBodyParts: action.__selectedBodyParts }
    case BodySurveyConstants.SET_COMMENTS:
      return { ...state, __comments: action.__comments }
    case BodySurveyConstants.DELETE_BODY_SURVEY_EXAM:
      return { ...state, __deleteExam: action.__deleteExam }
    case BodySurveyConstants.SET_DOCUMENT_FINDING:
      return { ...state, __documentFindings: action.__documentFindings }
    case BodySurveyConstants.DELETE_BODY_LOCATION_FINDING:
      return { ...state, __deleteBodyLocationFinding: action.__deleteBodyLocationFinding }
    case BodySurveyConstants.SET_CHEST_LUNG_MODE:
      return { ...state, __chestLungMode: action.__chestLungMode }
    case BodySurveyConstants.DELETE_SUMMARY_DATA:
      return {
        ...state,
        __deleteSummaryExams: action.__deleteSummaryExams,
        __deleteSummaryFindings: action.__deleteSummaryFindings,
      }
    case BodySurveyConstants.SET_SEQUENCE:
      return { ...state, __sequenceOperationType: action.__sequenceOperationType }
    case BodySurveyConstants.SET_EXAMINATION_IN_PROGRESS:
      return { ...state, __examinationInProgress: action.__examinationInProgress }
    case BodySurveyConstants.SET_ENABLE_ZOOM:
      return { ...state, __enabledZoom: action.__enabledZoom }
    case BodySurveyConstants.SET_DEFAULTS:
      return { ...state, __setDefaults: action.__setDefaults }
    case BodySurveyConstants.SET_ZOOM_VISIBLE:
      return { ...state, __setZoomVisible: action.__setZoomVisible }
    case BodySurveyConstants.SET_BOD_VALUE:
      return { ...state, __bod: action.__bod }
    case BodySurveyConstants.SET_BODY_SURVEY:
      return { ...action.bodySurvey }
    case BodySurveyConstants.RESET_BODY_SURVEY_VALUES:
      return {
        seq: state.seq,
        assessDt: getCurrentDateTime(),
        examValues: [],
        examValuesPNNVs: [],
        findings: [],
        __examValues: [],
        __examValuesPNNVs: [],
        __deleteExam: null,
        __zoomedBodyPart: null,
        __selectedBodyPart: null,
        __selectedBodyParts: [],
        __comments: '',
        __documentFindings: false,
        __deleteBodyLocationFinding: null,
        __deleteSummaryExams: [],
        __deleteSummaryFindings: [],
        __sequenceOperationType: '',
        __examinationInProgress: false,
        __enabledZoom: false,
        __setDefaults: false,
        __setZoomVisible: false,
        __bod: state.__bod,
      }
    case BodySurveyConstants.RESET_BODY_SURVEY_STATE:
      return {
        seq: 0,
        assessDt: getCurrentDateTime(),
        examValues: [],
        examValuesPNNVs: [],
        findings: [],
        __examValues: [],
        __examValuesPNNVs: [],
        __deleteExam: null,
        __zoomedBodyPart: null,
        __selectedBodyPart: null,
        __selectedBodyParts: [],
        __comments: '',
        __documentFindings: false,
        __deleteBodyLocationFinding: null,
        __chestLungMode: { id: 1, name: 'Front' },
        __deleteSummaryExams: [],
        __deleteSummaryFindings: [],
        __sequenceOperationType: '',
        __examinationInProgress: false,
        __enabledZoom: false,
        __setDefaults: false,
        __setZoomVisible: false,
        __bod: false,
      }

    default:
      return state
  }
}
